import React from 'react';

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    children: React.ReactNode;
    href: string;
    openNewTab?: boolean;
}

export default function ExternalLink({ children, openNewTab = true, ...props }: Props) {
    return (
        <a {...props} rel="noopener noreferrer" target={openNewTab ? '_blank' : ''}>
            {children}
        </a>
    );
}
